module.exports = __webpack_public_path__ + "static/Cati-0ef4f1dec567d36297350d97fc24f80a.jpg";